import React, { useEffect, useRef } from 'react';
import { AddressInput } from 'wix-style-react';
import { classes } from './BlackAddressInput.st.css';

const BlackAddressInput = (props: any) => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (props?.autoFocus) {
      ref.current?.focus();
    }
  }, [props?.autoFocus, ref]);

  return (
    <div className={classes.container}>
      <AddressInput
        {...props}
        className={classes.root}
        ref={ref}
        onFocus={(e) => e?.currentTarget?.click()}
      />
    </div>
  );
};

export default BlackAddressInput;
